import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Contact } from 'app/shared/models/contact.model';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit,OnDestroy  {
  @ViewChild('vform') validationForm: FormGroup;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  contactForm:FormGroup;
  fileData:File
  contact:any= new Contact();
  contactFormSubmitted:boolean=false;
  selectedBusinessId = null
  businessList: any[] = [];
  editData = null;
  isEdit=false;
  socailmediaList = []
  socialmedia_tagcat_id = '63e39e5b2052e0098e18e02a'
  
  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;
  business_list = []
  select_business = null
  contact_id: any
  select_socialmedia=null
  select_business_type=null
  business_type_List =[]
  refrences:any
  tag_cat_id:any
  currentUrl:any
  contact_model={
    name: '',
    phone: '',
    email: '',
    address: '',
    location: '',
    refrences: '',
    business_id: '',
    type_client: '',
    admin_notes: '',
    notes: '',
    role:''
  }
  users_List=[]
  select_refrence = null
  role_List =[
    {name:'Guest',_id:'guest'}
  ]
  select_role =null
  constructor(private formBuilder: FormBuilder,
    public toastr: ToastrService,
              public apiService:ApiService,
              private route:Router,
              private session: SessionStorageService,
              private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,private activatedroute: ActivatedRoute) { 
                this.locationAutoComplete();
                this.getAllUsers()
                this.currentUrl=this.activatedroute.snapshot.routeConfig.path
                if(this.currentUrl ==='add'){
                  this.activatedroute.queryParamMap.subscribe((params) => {
                    this.select_business = params.get('id');
                  });
                }
                if(this.currentUrl ==='edit/:id'){
                  this.activatedroute.paramMap.subscribe((params) => {
                    this.contact_id = params.get('id');
                  });
                 
                }
              }

  ngOnInit() {
    this.contactForm=this.formBuilder.group({
      name: ['', Validators.required],
      email: ['',],
      phone: ['',],
      address: ['', ],
      notes: ['',],
      admin_notes: ['',],
    })
    // this.getScoialMediaTags()
    this.getAllBusinessList()
    this.getTagCatList()
    if( this.currentUrl ==='edit/:id'){
      this.getContactById(this.contact_id)
    }
  }
  getContactById(id){
    this.apiService.getContactById(id).subscribe((res:any)=>{
      this.contact_model.name = res?.data?.name
      this.contact_model.email = res?.data?.email
      this.contact_model.phone = res?.data?.phone
      this.contact_model.address = res?.data?.address
      this.contact_model.refrences = res?.data?.refrences
      this.select_business = res?.data?.business_id?._id
      this.contact_model.business_id =  this.select_business
      this.select_business_type = res?.data?.type_client?._id
      this.contact_model.type_client =  this.select_business_type
      this.contact_model.admin_notes = res?.data?.admin_notes
      this.contact_model.notes = res?.data?.notes
      this.select_role =  res?.data?.user[0]?.roles
      this.contact_model.role = this.select_role  

    })
  }
  getTagCatList(){
    this.apiService.getAllCategory(1,100).subscribe((res:any)=>{
      let cat = res?.data?.items.find((item)=> item.name =='businesstype')
      this.tag_cat_id = cat._id
      if(this.tag_cat_id){
        this.getBusinessTypeList(this.tag_cat_id)
      }
    })
  }
  getBusinessTypeList(id){
    this.apiService.getTagByTagCatgoryId(id).subscribe((res:any)=>{
      this.business_type_List=res?.data
    })
  }
   getAllBusinessList(){
    this.apiService.getBusinessList(1,1000).subscribe((res:any)=>{
      this.business_list =res?.data?.items
    })
  }
  getBusinessId(event) {
    this.select_business
}
  getBusinessType(event){
    this.select_business_type
  }
  ngOnDestroy(){
    this.session.removeItem('contact-data')
  }
  get rf() {
    return this.contactForm.controls;
  }
  submit(){   
  
    if (!this.contact_id) {
      let body={
      name:this.contactForm.value.name,
      email:this.contactForm.value.email,
      phone:this.contactForm.value.phone,
      address:this.address,
      landmark:this.contactForm.value.landmark,
      notes:this.contactForm.value.notes,
      admin_notes:this.contactForm.value.admin_notes,
      lat:this.latitude,
      lng: this.longitude,
      business_id: this.select_business,
      refrences: this.refrences,
      type_client : this.select_business_type,
      refrence: this.select_refrence ,
      role: this.select_role
    }
    
    this.apiService.createContact(body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('added successfully')
        history.back()
      }
      else this.toastr.error(res.error)
    })
    }
    if (this.contact_id) {
      this.contact_model.business_id= this.select_business
      this.contact_model.type_client = this.select_business_type
      // this.contact_model.socialmedia = this.select_socialmedia
      this.contact_model.refrences = this.refrences
      this.contact_model.role = this.select_role
       this.apiService.updateContact(this.contact_id,this.contact_model).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('updated successfull')
        history.back()
      }
      else this.toastr.error(res.error)
    })
    }
    
  }
 back(){
  this.route.navigate(['/contact/list'])    
 } 
 getScoialMediaTags() {
  this.apiService.getTagByTagCatgoryId(this.socialmedia_tagcat_id).subscribe((res: any) => {
    this.socailmediaList = res.data
  })
}
getChangeSocialMedia(event) {
  this.select_socialmedia
}
locationAutoComplete() {
  this.mapsAPILoader.load().then(() => {
    this.geoCoder = new google.maps.Geocoder;

    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        this.address = place.formatted_address;
        console.log('address', this.address)
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        // set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        console.log("lat lng", this.latitude, this.longitude)
      });
    });
  });
}
setFocus(event) {
  this.refrences = event.html
}
getAllUsers(){
  this.apiService.getAllUsers(1,1000).subscribe((res:any)=>{
    this.users_List = res?.data?.items
  })
}
getRefrenceId(event){
  this.select_refrence
}
getRoleId(event){
  this.select_role
}
}


